import { apiInstance } from 'api/utils';

// Existing policies
const policiesApi = {
  getPolicies: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/policies/`
    });
  },
  createNewPolicy: ({ portfolio, data }: { portfolio: any; data: any }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/`,
      data: data
    });
  },
  requestAdvisorChargeOnPolicy: ({
    portfolio,
    policyId,
    advisorChargeData
  }: {
    portfolio: any;
    policyId: number;
    advisorChargeData: {
      amount?: string | number;
      percentage_value?: string;
      charge_type: number;
    };
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${policyId}/advisor-charges/request/`,
      data: advisorChargeData
    });
  },
  applyAdvisorChargeOnPolicy: ({
    portfolio,
    policyId,
    advisorChargeData
  }: {
    portfolio: any;
    policyId: number;
    advisorChargeData: {
      amount: number;
      charge_type: number;
    };
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${policyId}/advisor-charges/apply/`,
      data: advisorChargeData
    });
  },
  paidDirectlyAdvisorCharge: ({
    portfolio,
    advisorChargeData,
    policyId
  }: {
    portfolio: any;
    advisorChargeData: {
      amount: number;
      charge_type: number;
    };
    policyId: number;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${policyId}/advisor-charges/apply-directly/`,
      data: advisorChargeData
    });
  },
  getPolicy: ({ portfolio, policyId }: { portfolio: any; policyId: any }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/policies/${policyId}/`
    }),
  updatePolicy: ({
    portfolio,
    policyId,
    policyData
  }: {
    portfolio: any;
    policyId: any;
    policyData: any;
  }) =>
    apiInstance.request({
      method: 'PATCH',
      url: `/cases/${portfolio}/policies/${policyId}/`,
      data: policyData
    }),
  removePolicy: ({
    policyId,
    portfolio
  }: {
    policyId: string | number;
    portfolio: any;
  }) =>
    apiInstance.request({
      method: 'DELETE',
      url: `/cases/${portfolio}/policies/${policyId}/`
    }),
  createNewPolicyWithContribution: ({
    portfolio,
    policy,
    contribution
  }: {
    portfolio: any;
    policy: any;
    contribution: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/from-contribution/`,
      data: {
        contribution,
        policy
      }
    });
  },
  setChargeablePolicy: (portfolio: number, id: number) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${id}/chargeable/`
    });
  },
  overridePolicy: ({
    policyId,
    portfolio,
    overrideId
  }: {
    policyId: string | number;
    portfolio: any;
    overrideId: number;
  }) =>
    apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/policies/${policyId}/override/`,
      data: {
        id: overrideId
      }
    }),
  removeOverride: ({
    policyId,
    portfolio
  }: {
    policyId: string | number;
    portfolio: any;
  }) =>
    apiInstance.request({
      method: 'DELETE',
      url: `/cases/${portfolio}/policies/${policyId}/override/`
    }),
  getPolicyRiskRating: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: `/funds/risk-ratings/`,
      data
    }),
  getCipOptions: () =>
    apiInstance.request({
      method: 'GET',
      url: `/funds/risk-ratings/`
    }),
  getFundRiskRating: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/fund-risk-rating',
      data
    }),
  getMorningstarRiskRating: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/morningstar-risk-ratings',
      data
    }),
  updateCip: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/update-policy-cip-template',
      data
    }),
  deleteCipFundAllocation: (data: any) =>
    apiInstance.request({
      method: 'DELETE',
      url: '/update-policy-cip-template',
      data
    }),
  getCashFund: () =>
    apiInstance.request({
      method: 'GET',
      url: `/funds/cash/`
    }),
  updateCurrentHolidings: () =>
    apiInstance.request({
      method: 'GET',
      url: `/update-current-holdings`
    })
};

export default {
  ...policiesApi
};
